import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button } from 'semantic-ui-react'
const { Group } = Button

export default function ButtonsInput(props) {
  let {
    value: fieldValue,
    options,
    name,
    id,
    onChange,
    disabled,
    multiple = false,
    color = 'green',
    size = 'medium',
  } = props

  let buttonProps = { size }

  if (color) buttonProps.color = color

  if (!List.isList(fieldValue)) fieldValue = List(fieldValue)

  return (
    <Group>
      {options.map(({ value, label, icon = false, hint = false }) => {
        let inputProps = {
          content: label,
          active: fieldValue.contains(value),
          icon,
          key: value,
          size: 'tiny',
          onClick: e => {
            e.preventDefault()

            let changeValue = value
            if (multiple)
              changeValue = fieldValue.contains(value)
                ? fieldValue.remove(fieldValue.indexOf(value))
                : fieldValue.push(value)

            onChange({ name, value: changeValue })
          },
        }

        if (hint) {
          inputProps['data-hint'] = hint
          inputProps['className'] = 'hint hint--top'
        }

        return <Button {...inputProps} {...buttonProps} />
      })}
    </Group>
  )
}
